export default "__VITE_ASSET__d86cf12b__"